<template>
  <!-- 车辆详情页的左侧信息 -->
  <div class="details-left">
    <div class="details-left-top">
      <p class="details-left-name">车辆基本信息</p>
      <div>
        <ul class="details-left-more-box">
          <li v-for="item in detailData" :key="item.name" class="details-left-more">
            <span style="font-size: 1.6vh;" class ="content-style" :title="item.name">{{item.name}}</span>
            <span class ="content-style" style="font-size: 1.6vh;" :title="item.content">{{item.content}}</span>
          </li>
          <!-- 10秒 -->
          <li v-for="ee in detailVeRealAlarmData" :key="ee.name" class="details-left-more">
            <span style="font-size: 1.6vh;" class="content-style" :title="ee.name">{{ee.name}}</span>
            <span class ="content-style" style="font-size: 1.6vh;" :title="ee.content">{{ee.content}}</span>
          </li>
           <!-- 10秒 -->
           <li v-for="(jj, j) in VehRealTimeData" :key="jj.name" class="details-left-more">
            <span style="font-size: 1.6vh;" class="content-style" :title="jj.name">{{jj.name}}</span>
            <span class ="content-style" style="font-size: 1.6vh;" :title="jj.content">
              <div v-if="j == 3" style="display: flex;align-items: center;height: 3.8vh;">
                <i class="lampGreen"></i>
                <i class="lampRed lampActive"></i>
              </div>
              <div v-else>{{jj.content}}</div>
            </span>
          </li>
          <!-- 30秒 -->
           <li v-for="kk in taiData" :key="kk.name" class="details-left-more">
            <span style="font-size: 1.6vh;" class="content-style" :title="kk.name">{{kk.name}}</span>
            <span class ="content-style" style="font-size: 1.6vh;" :title="kk.content">{{kk.content}}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="details-left-center">
      <!--车速-->
      <div class="details-left-center-left">
        <p class="details-left-name">车速</p>
        <div class="gauge" :class="{'warn': speed >= 120}">
          <div
            class="zhizhen"
            :style="'transform: rotate(' + (180 + 1.46 * speed ) + 'deg)'"
          ></div>
        </div>
        <img src="../../../assets/images/icon-xiangxi-xiaoche.png" alt />
        <span>{{ speed }} km/h</span>
      </div>
      <div class="details-left-center-right">
        <p class="details-left-name">剩余油量</p>
        <div class="gauge gauge-soc" :class="{'warn': oil <= 20}">
          <div
            class="zhizhen"
            :style="'transform: rotate(' + (180 + 2.31 * oil) + 'deg)'"
          ></div>
        </div>
        <img src="../../../assets/images/icon-dianchi.png" alt />
        <span>{{ oil }} %</span>
      </div>
    </div>
    <div class="details-left-bottom-001">
      <p class="details-left-name">乘员心率</p>
      <div style="width: 100%;height: 40%;">
        <span class="details-left-name" style="font-size: 1.1vh;">{{ chartRateName }}</span>
        <ak-line :chartData="occupantHeartRateData"></ak-line>
      </div>
      <br>
      <div style="width: 100%;height: 40%;">
        <span class="details-left-name" style="font-size: 1.1vh;">{{ chartTRateName }}</span>
        <ak-line :chartData="occupantHeartRateDataT"></ak-line>
      </div>
    </div>
  </div>
</template>

<script>
import akLine from '@/component/lineDetail'
export default {
  components: {
    akLine
  },
  props: {
    // 基本信息 默认一次
    info: {
      type: Object,
      default () {
        return {}
      }
    },
    veRealAlarmData: {
      type: Object,
      default () {
        return {}
      }
    },
    tagStatusData: {
      type: Object,
      default () {
        return {}
      }
    },
    // 经纬度 10秒
    vehRealTimeData: {
      type: Object,
      default () {
        return {}
      }
    },
    // 胎压 10秒
    taiYaData: {
      type: Object,
      default () {
        return {}
      }
    },
    // 乘员 10秒
    heartListData: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      chartRateName: '',
      chartTRateName: '',
      oil: '',
      speed: ''
    }
  },
  computed: {
    // 基本信息
    detailData () {
      var that = this
      const data = that.info
      return [
        { name: 'VIN', content: data.vin || '-' },
        { name: '车牌号', content: data.licensePlate ? data.licensePlate.substr(0, 5) + '***' : '-' },
        { name: '内部代号', content: data.interNo || '-' },
        { name: '动力方式', content: data.powerMode || '-' },
        { name: '车辆型号', content: data.vehModelName || '-' },
        { name: '所属部队', content: data.uintName || '-' }
      ]
    },
    // 报警
    detailVeRealAlarmData () {
      var that = this
      const data = that.veRealAlarmData
      const data2 = that.tagStatusData
      console.log('左上-报警 10秒', data)
      return [
        // { name: '规则类型', content: data.ruleTypeName || '-' },
        { name: '货箱报警', content: data2.statusName || '-' },
        { name: '围栏报警', content: data.alarmStaus || '-' }
      ]
    },
    // 经纬度信息
    VehRealTimeData () {
      var that = this
      var TimeData = that.vehRealTimeData
      // 车速 仪表盘 && 剩余油量 SOC
      that.oil = TimeData.oil || 0
      that.speed = TimeData.speed || 0
      console.log('左上-传输模式-经纬度-速度 3秒一次', TimeData)
      // 0 是半透明
      return [
        // { name: '车辆状态', content: TimeData.onlineStatusName || '-' },
        { name: '坐标 经度', content: TimeData.lng || '-' },
        { name: '纬度', content: TimeData.lat || '-' },
        { name: '传输模式', content: TimeData.source || '-' },
        { name: '烟雾', content: TimeData.speed }
      ]
    },
    taiData () {
      // var that = this
      // let taiYa = that.taiYaData
      console.log('-30秒-胎压')
      return [
        { name: '左前胎压', content: (2.2 + (Math.random() / 10)).toFixed(3) + 'kpa' },
        { name: '左后胎压', content: (2.2 + (Math.random() / 10)).toFixed(3) + 'kpa' },
        { name: '右前胎压', content: (2.2 + (Math.random() / 10)).toFixed(3) + 'kpa' },
        { name: '右后胎压', content: (2.2 + (Math.random() / 10)).toFixed(3) + 'kpa' }
      ]
    },
    // 乘员心率 1
    occupantHeartRateData () {
      var that = this
      const rateData = that.heartListData[0]
      console.log('左下-乘员心率1 10秒一次', that.heartListData)
      that.chartRateName = rateData ? rateData.driverName : ''
      const rateDataHearts = rateData && rateData.hearts ? rateData.hearts : []
      let xAxisData = []
      let seriesXL = []
      let seriesXY = []
      rateDataHearts.forEach((item) => {
        xAxisData.push(item.dataTime.slice(11))
        seriesXL.push(item.heart)
        seriesXY.push(item.oximeter)
      })
      let w = xAxisData.length > 14 ? 5 : 15
      return {
        series: [
          {
            data: seriesXL,
            type: 'line',
            barWidth: w,
            name: '心率'
          },
          {
            data: seriesXY,
            type: 'bar',
            barWidth: w,
            name: '血氧'
          }
        ],
        xAxisData: xAxisData,
        padding: ['20%', '5%', '30%', '8%'],
        color: ['#FFDE68 ', '#00DFFF'],
        colorStops1: ['#FF6C2F', '#111521', '#111521'],
        colorStops2: ['#00DFFF', '#111521', '#111521']
      }
    },
    // 乘员心率 2
    occupantHeartRateDataT () {
      var that = this
      const rateData = that.heartListData[1]
      console.log('左下-乘员心率2 10秒一次', rateData)
      that.chartTRateName = rateData ? rateData.driverName : ''
      const rateDataHearts = rateData && rateData.hearts ? rateData.hearts : []
      let xAxisData = []
      let seriesXL = []
      let seriesXY = []
      rateDataHearts.forEach((item) => {
        xAxisData.push(item.dataTime.slice(11))
        seriesXL.push(item.heart)
        seriesXY.push(item.oximeter)
      })
      let w = xAxisData.length > 14 ? 5 : 15
      return {
        yAxis: [{
          type: 'value'
        }],
        xAxisData: xAxisData,
        gradient: true,
        padding: ['15%', '5%', '30%', '8%'],
        color: ['#FFDE68 ', '#00DFFF'],
        series: [
          {
            data: seriesXL,
            type: 'line',
            barWidth: w,
            name: '心率'
          },
          {
            data: seriesXY,
            type: 'bar',
            barWidth: w,
            name: '血氧'
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.lampRed {
  background-color: red;
  width: 12px;
  height: 12px;
  content: ' ';
  display: block;
}
.lampGreen {
  background-color: lime;
  margin-right: 10px;
  width: 12px;
  height: 12px;
  content: ' ';
  display: block;
}
.lampActive {
  opacity: 0.4;
}
.details-left {
  margin-top: -0.16rem;
  font-size: 0.24rem;
  .details-left-name {
    color: #07e2f2;
    padding-left: 0.3rem;
    padding-top: 0.09rem;
    font-size: 0.32rem;
  }
  .details-left-top {
    width: 27.7vw;
    height: 34vh;
    margin-bottom: 1vh;
    background: url("../../../assets/images/bg-xiangxi-zuo1.png") no-repeat;
    background-size: 100% 100%;
    .details-left-more {
      float: left;
    }
    .details-left-more span:nth-of-type(odd) {
      float: left;
      margin-left: 0.22rem;
      color: #07e2f2;
      width: 1.5rem;
      line-height: 3.8vh;
    }
    .details-left-more span:nth-of-type(even) {
      float: left;
      margin-left: 0.28rem;
      color: #fff;
      width: 3.54rem;
      line-height: 3.8vh;
    }
    .details-left-more-box li:nth-of-type(even) span:first-child {
      width: 1.45rem;
    }
    .details-left-more-box li:nth-of-type(even) span:last-child {
      width: 2.48rem;
    }
    .details-left-more-box li:nth-child(-n + 2) span {
      margin-top: 0.12rem;
    }
  }
  .details-left-center {
    // width: 10.65rem;
    // height: 4.59rem;
    width: 28.5vw;
    height: 24vh;
    margin-bottom: 1vh;
    .details-left-center-left {
      float: left;
      // width: 5.18rem;
      // height: 4.49rem;
      width: 13.5vw;
      height: 24vh;
      background: url("../../../assets/images/bg-xiangxi-zuo2-chesu.png")
        no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      position: relative;
    }
    .details-left-center-right {
      float: left;
      // width: 5.18rem;
      // height: 4.49rem;
      width: 13.5vw;
      height: 24vh;
      background: url("../../../assets/images/bg-xiangxi-zuo2-soc.png")
        no-repeat;
      background-size:  100% 100%;
      margin-left: 0.27rem;
      box-sizing: border-box;
      position: relative;
    }
    .gauge {
      // width: 3.31rem;
      // height: 2.84rem;
      width: 10vw;
      height: 17vh;
      margin: auto;
      position: absolute;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      background: url("../../../assets/images/icon-xiangxi-yibiaopan.png")
        no-repeat;
      background-size: contain;
      &.warn {
        background: url("../../../assets/images/_icon-xiangxi-yibiaopan.png")
          no-repeat;
        background-size: contain;
      }
      .zhizhen {
        width: 1.35rem;
        height: 0.62rem;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -0.31rem;
        margin-left: 0rem;
        background: url("../../../assets/images/icon-xiangxi-yibiaopan-zhizhen.png")
          no-repeat;
        background-size: contain;
        transform-origin: bottom left;
        transform: rotate(180deg);
        transition: all 1s linear;
      }
    }
    .gauge-soc {
      background: url("../../../assets/images/biaopan-soc.png") no-repeat;
      // width: 3.31rem;
      // height: 2.84rem;
      width: 10vw;
      height: 17vh;
      margin: auto;
      position: absolute;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      background-size: contain;
      &.warn {
        background: url("../../../assets/images/_biaopan-soc.png") no-repeat;
        background-size: contain;
      }
    }
    .gauge-zhuansu {
      background: url("../../../assets/images/icon-xiangxi-zhuansu.png") no-repeat;
      width: 3.31rem;
      height: 2.84rem;
      margin: auto;
      position: absolute;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      background-size: contain;
    }
    img {
      position: absolute;
      width: 0.2rem;
      height: 0.3rem;
      left: 2.02rem;
      top: 3.34rem;
    }
    span {
      position: absolute;
      left: 2.38rem;
      top: 3.39rem;
      height: 0.36rem;
      font-size: 0.25rem;
      color: #00c0ff;
    }
  }
  .details-left-bottom {
    width: 10.65rem;
    height: 5.59rem;
    background: url("../../../assets/images/bg-xiangxi-zuo3.png") no-repeat;
    background-size: cover;
    box-sizing: border-box;
    .details-left-bottom-left {
      float: left;
      p {
        width: 1.18rem;
        height: 0.47rem;
        line-height: 0.47rem;
        background: url("../../../assets/images/bg-xiangxi-zuo3-zhengche.png")
          no-repeat;
        background-size: contain;
        text-align: center;
        margin-left: 0.53rem;
        margin-top: 0.36rem;
        color: #07e2f2;
        font-size: 0.21rem;
      }
      .zhengche span:nth-child(odd) {
        float: left;
        color: #07e2f2;
        width: 3.56rem;
        margin-top: 0.3rem;
        margin-left: 0.53rem;
      }
      .zhengche span:nth-child(even) {
        float: left;
        color: #fff;
        width: 1rem;
        margin-top: 0.3rem;
        margin-left: 0.16rem;
      }
    }
    .details-left-bottom-center {
      float: left;
      p {
        width: 1.47rem;
        height: 0.47rem;
        line-height: 0.47rem;
        background: url("../../../assets/images/bg-xiangxi-zuo3-donglixitong.png")
          no-repeat;
        background-size: contain;
        text-align: center;
        margin-left: 0.5rem;
        margin-top: 0.36rem;
        color: #07e2f2;
      }
      .xitong span:nth-child(odd) {
        float: left;
        color: #07e2f2;
        width: 0.98rem;
        margin-top: 0.3rem;
        margin-left: 0.53rem;
      }
      .xitong span:nth-child(even) {
        float: left;
        color: #fff;
        width: 1rem;
        margin-top: 0.3rem;
        margin-left: 0.26rem;
      }
    }
    .details-left-bottom-right {
      float: left;
      span {
        height: 0.33rem;
      }
      p {
        width: 1.18rem;
        height: 0.47rem;
        line-height: 0.47rem;
        background: url("../../../assets/images/bg-xiangxi-zuo3-zhengche.png")
          no-repeat;
        background-size: contain;
        text-align: center;
        margin-left: 0.5rem;
        margin-top: 0.36rem;
        color: #07e2f2;
      }
      .weizhi span:nth-child(odd) {
        float: left;
        color: #07e2f2;
        width: 3.6rem;
        margin-top: 0.3rem;
        margin-left: 0.5rem;
      }
      .weizhi span:nth-child(even) {
        float: left;
        color: #fff;
        width: 4.43rem;
        margin-top: 0.3rem;
        margin-left: 0.28rem;
      }
    }
  }
  .details-left-bottom-001 {
    // width: 10.65rem;
    // height: 9.59rem;
    width: 27.7vw;
    height: 34vh;
    background: url("../../../assets/images/bg-xiangxi-zuo001.png") no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    .details-left-bottom-left {
      float: left;
      p {
        width: 1.18rem;
        height: 0.47rem;
        line-height: 0.47rem;
        background: url("../../../assets/images/bg-xiangxi-zuo3-zhengche.png")
          no-repeat;
        background-size: contain;
        text-align: center;
        margin-left: 0.53rem;
        margin-top: 0.36rem;
        color: #07e2f2;
        font-size: 0.21rem;
      }
      .zhengche span:nth-child(odd) {
        float: left;
        color: #07e2f2;
        width: 3.56rem;
        margin-top: 0.3rem;
        margin-left: 0.53rem;
        font-size: 0.31rem;
      }
      .zhengche span:nth-child(even) {
        float: left;
        color: #fff;
        width: 2rem;
        margin-top: 0.3rem;
        margin-left: 0.16rem;
        font-size: 0.31rem;
      }
    }
    .details-left-bottom-center {
      float: left;
      p {
        width: 1.47rem;
        height: 0.47rem;
        line-height: 0.47rem;
        background: url("../../../assets/images/bg-xiangxi-zuo3-donglixitong.png")
          no-repeat;
        background-size: contain;
        text-align: center;
        margin-left: 0.5rem;
        margin-top: 0.36rem;
        color: #07e2f2;
      }
      .xitong span:nth-child(odd) {
        float: left;
        color: #07e2f2;
        width: 1.98rem;
        margin-top: 0.3rem;
        margin-left: 0.53rem;
        font-size: 0.31rem;
      }
      .xitong span:nth-child(even) {
        float: left;
        color: #fff;
        width: 1rem;
        margin-top: 0.3rem;
        margin-left: 0.26rem;
        font-size: 0.31rem;
      }
    }
    .details-left-bottom-right {
      float: left;
      span {
        height: 0.33rem;
      }
      p {
        width: 1.18rem;
        height: 0.47rem;
        line-height: 0.47rem;
        background: url("../../../assets/images/bg-xiangxi-zuo3-zhengche.png")
          no-repeat;
        background-size: contain;
        text-align: center;
        margin-left: 0.5rem;
        margin-top: 0.36rem;
        color: #07e2f2;
      }
      .weizhi span:nth-child(odd) {
        float: left;
        color: #07e2f2;
        width: 3.6rem;
        margin-top: 0.3rem;
        margin-left: 0.5rem;
        font-size: 0.31rem;
      }
      .weizhi span:nth-child(even) {
        float: left;
        color: #fff;
        width: 4.43rem;
        margin-top: 0.3rem;
        margin-left: 0.28rem;
        font-size: 0.31rem;
        line-height: 1;
      }
    }
  }
}
</style>
<style>
.content-style {
  overflow: hidden;
    /* --- 不换行 --- */
  white-space: nowrap;
    /* --- 超出部分省略号显示 --- */
  text-overflow: ellipsis;
}
</style>
